import { hbg, pro, ucHbg } from "./http.service";

export const apiInvite = {
  /**
     * 创建双向返佣的邀请码
     * inviter_rate	string	[0,1]	Y	邀请人返佣比例
     invitee_rate	string	[0,1]	Y	被邀请人返现比例
     second_level_rate	string	[0,1]	Y	二级邀请比例(没有0，有最大为0.05)
     remark	string	[0,255]	N	备注
     defaultCode	int	[2]	N	是否设置为默认邀请码 0 否 1 是
     * */
  inviteCodeCreate(data) {
    return ucHbg.post("/hbg/uc/hbg/open/invite/v2/invite_code/create", {
      data,
    });
  },
  kolFuturesActivity() {
    return hbg.get("/activity-game/v1/kol/user/rank/query", {});
  },
  // 是否能添加下级
  mutiFlag() {
    return hbg.get("/hbg/uc/hbg/open/invite/v2/muti/flag", {});
  },
  inviteNewCodeCreate(data) {
    return ucHbg.post(
      "/hbg/uc/hbg/open/invite/v2/invite_code/create/currentUid",
      {
        data,
      }
    );
  },
  checkFuturesKol() {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/kol/user", {});
  },
  domainNameUrl() {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/kol/domainNameUrl", {});
  },
  inviteShortPath() {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/getInviteUrl", {});
  },
  checkKol() {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/inviter_award/checkKol", {});
  },
  // 判断是否韩国用户，true是
  checkKoreanKol() {
    return hbg.get("/hbg/uc/hbg/open/invite/v2/kol/check", {});
  },
  getFundList(data) {
    return ucHbg.post("/hbg/uc/hbg/open/invite/fund/list", { data });
  },
  getFundExcel(data) {
    return ucHbg.post("/hbg/uc/hbg/open/invite/fund/export", { data });
  },
  mutiConfigGet() {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/muti/muti_config_get", {});
  },
  subUserSet(data) {
    return ucHbg.post("/hbg/uc/hbg/open/invite/v2/muti/send_mail", { data });
  },
  partnerAddValidation(params) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/muti/partnerAddValidation", { params });
  },
  partnerAddCheck() {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/muti/partnerAddCheck", {});
  },
  emailCheckLeft(params) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/muti/emailCheckLeft", {params});
  },
  subUserList() {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/muti/sub_user_list", {});
  },
  subUserDel(data) {
    return ucHbg.post("/hbg/uc/hbg/open/invite/v2/muti/sub_user_cancel", {
      data,
    });
  },
  levelList() {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/muti/level_list", {});
  },
  rebateList() {
    return ucHbg.get("/hbg/open/invite/brokerage/income/isWhite", {});
  },
  /**
   * 获取当前登录用户邀请人信息-返回v2的邀请人数据
   * */
  inviterGet(params = {}) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/inviter/get", { params });
  },
  /**
   * 查询返佣收益明细
   * */
  getAggregationDay(params) {
    return pro.get("/pro/v1/inviter/brokerage/aggregation/sum", { params });
  },
  /**
   * 查询返佣收益总计
   * */
  getAggregation() {
    return pro.get("/pro/v1/inviter/brokerage/aggregation", {});
  },
  /**
   * 查询来自好友返现
   * */
  getCashbackTotal() {
    return pro.get("/pro/v1/cashback/total", {});
  },
  /**
   * 获取列表
   * */
  inviteeList(params) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/kol/invitee_list", { params });
  },
  /**
   * 是否展示primebox
   * */
  getStage() {
    return hbg.get("/hbg/v1/prime-box/detail", {});
  },
  /**
   * 获取列表
   * */
  init_page(params) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/kol/init_page", { params });
  },
  /**
   * 获取邀请人数
   * */
  kolGetNum(params) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/kol/get_num", { params });
  },
  getRate(params = {}) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/default/get_rate", { params });
  },

  /**
   * 设置默认邀请码
   * */
  setDefault(data) {
    return ucHbg.post("/hbg/uc/hbg/open/invite/v2/invite_code/default/set", {
      data,
    });
  },
  setNewDefault(data) {
    return ucHbg.post(
      "/hbg/uc/hbg/open/invite/v2/invite_code/default/set/currentUid",
      {
        data,
      }
    );
  },
  /**
   * 导出返佣记录
   * */
  exportHistory(params) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/kol/invitee_list/export", {
      params,
    });
  },
  /**
   * 获取默认邀请码信息
   * */
  getDefaultInviteCodeInfo(params) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/invite_code/default/get", {
      params,
    });
  },
  getNewDefaultInviteCodeInfo(params) {
    return ucHbg.get(
      "/hbg/uc/hbg/open/invite/v2/invite_code/default/get/currentUid",
      {
        params,
      }
    );
  },
  /**
   * 获取邀请码列表
   * */
  getInviteCodeList(params) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/invite_code/list", { params });
  },
  
  getNewInviteCodeList(params) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/invite_code/list/currentUid", {
      params,
    });
  },
  // 查询创建邀请码剩余次数
  queryCodeCreateCount() {
    return ucHbg.post("/hbg/uc/hbg/open/invite/v2/inviteCode/queryCodeCreateCount",{});
  },
  // 自动生成邀请码
  inviteCodeGenerator() {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/inviteCode/inviteCodeGenerator",{});
  },
  // 邀请码校验
  customCodeCheck(params) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/inviteCode/customCodeCheck",{params});
  },
  // 是否展示靓码抢注图标
  inviteCodeCustomIcon(params) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/inviteCode/inviteCodeCustomIcon",{params});
  },
   // 是否提示看板升级
   dashboardUpgradeAlert(params: any) {
    return ucHbg.get('/hbg/uc/hbg/open/invite/v2/kol/dashboardUpgradeAlert', { params });
  },
  //是否在白名单
  inviteCodeCustomHit(params) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/inviteCode/inviteCodeCustomHit",{params});
  },
  getcashback(params = {}) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/default/cashback", { params });
  },
  /**
   * 获取日返佣收益明细
   * */
  getEarnList(params) {
    return ucHbg.get("/hbg/open/invite/brokerage/income/list", { params });
  },

  getNewEarnList(params) {
    return ucHbg.get("/hbg/open/invite/brokerage/income/list/v2", { params });
  },
  /**
   * 被邀请人贡献收益明细
   * */
  getEarnDetailList(params) {
    return ucHbg.get("/hbg/open/invite/brokerage/income/detail", { params });
  },

  /**
   *  start---------------------------------------------------
   * 多级返佣收益看板
   * */

  //多级返佣累计收益（昨日）
  getPreDayMultistageEarnData() {
    return ucHbg.get(
      "/hbg/uc/hbg/open/invite/v2/multi/data/getPreDayMultistageEarnData",
      {}
    );
  },

  //多级返佣累计收益（累计）
  getMultistageEarnData(params) {
    return ucHbg.post(
      "/hbg/uc/hbg/open/invite/v2/multi/data/getMultistageEarnData",
      { data: params }
    );
  },

  // 我的邀请
  getMyInvitationData() {
    return ucHbg.get(
      "/hbg/uc/hbg/open/invite/v2/multi/data/getMyInvitationData",
      {}
    );
  },
  // 明细数据
  getSubMultiData(params) {
    return ucHbg.post("/hbg/uc/hbg/open/invite/v2/multi/data/getSubMultiData", {
      data: params,
    });
  },

  /**
   *  多级返佣收益看板end--------------------------------------------
   * */

  /**
   *  多级返佣收益看板start--------------------------------------------
   * */

  // 授权协议弹窗状态
  getAgreeStatus() {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/multi/data/getAgreeStatus", {
      data: {},
    });
  },
  // M2弹窗状态
  getConfirmStatus() {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/multi/data/getConfirmStatus", {
      data: {},
    });
  },
  // 申请授权
  applyStatus(params) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/multi/data/applyStatus", {
      params,
    });
  },
  // M2 确认/取消授权
  confirmStatus(params) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/multi/data/confirmStatus", {
      params,
    });
  },
  // 授权弹窗
  agreeStatus(params) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/multi/data/agreeStatus", {
      params,
    });
  },
  /**
   *  多级返佣收益看板end--------------------------------------------
   * */

  /**
   *  start---------------------------------------------------
   * KOL 2.0
   * */

  //合伙人列表
  getPartnerListData(params) {
    return ucHbg.post(
      "/hbg/uc/hbg/open/invite/v2/multi/data/getPartnerListData",
      { data: params }
    );
  },
  //返佣收益
  getCommissionListData(params = {}) {
    return ucHbg.post(
      "/hbg/uc/hbg/open/invite/v2/multi/data/getCommissionListData",
      { data: params }
    );
  },

  // myCommission
  myCommission(params) {
    return ucHbg.post("/hbg/uc/hbg/open/invite/v2/multi/data/myCommission", {
      data: params,
    });
  },

  // partnerCommission
  partnerCommission(params) {
    return ucHbg.post(
      "/hbg/uc/hbg/open/invite/v2/multi/data/partnerCommission",
      { data: params }
    );
  },

  // userCommission
  userCommission(params) {
    return ucHbg.post("/hbg/uc/hbg/open/invite/v2/multi/data/userCommission", {
      data: params,
    });
  },
  incomeKol(params = {}) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/brokerage/income/kol", {
      params,
    });
  },
  positionList(params) {
    return ucHbg.post("/hbg/uc/hbg/open/invite/contract/position/list", {
      data: params,
    });
  },
  positionExport(params) {
    return ucHbg.post("/hbg/uc/hbg/open/invite/contract/position/export", {
      data: params,
    });
  },
  getUserInfoList(params = {}) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/dashboard/getUserInfoList", {
      params,
    });
  },
  getUserInfoStatistics(params = {}) {
    return ucHbg.get(
      "/hbg/uc/hbg/open/invite/v2/dashboard/getUserInfoStatistics",
      { params }
    );
  },
  UserListExport(params) {
    return ucHbg.post(
      "/hbg/uc/hbg/open/invite/v2/dashboard/getUserInfoList/export",
      { data: params }
    );
  },

  // 用户返佣统计
  UserRebateStatistic(params) {
    return ucHbg.post(
      "/hbg/uc/hbg/open/invite/v2/dashboard/getRebateStatistic",
      { data: params }
    );
  },
  // 用户邀友统计
  InviteStatistic(params) {
    return ucHbg.post(
      "/hbg/uc/hbg/open/invite/v2/dashboard/getInviteStatistic",
      { data: params }
    );
  },
  // 最近邀请的人
  RecentInvitee(params) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/dashboard/getRecentInvitee", {
      params,
    });
  },
  // 统计图表是否是白名单用户
  getStatisticWhite(params) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/dashboard/getStatisticWhite", {
      params,
    });
  },
  spotHistoryOrderListExport(params) {
    return ucHbg.post(
      "/hbg/uc/hbg/open/invite/v2/dashboard/getSpotHistoryOrderList/export",
      { data: params }
    );
  },
  spotOpenOrderListExport(params) {
    return ucHbg.post(
      "/hbg/uc/hbg/open/invite/v2/dashboard/getSpotOpenOrderList/export",
      { data: params }
    );
  },
  getOrderHistoryList(params = {}) {
    return ucHbg.get(
      "/hbg/uc/hbg/open/invite/v2/dashboard/getOrderHistoryList",
      { params }
    );
  },
  OrderListExport(params) {
    return ucHbg.post(
      "/hbg/uc/hbg/open/invite/v2/dashboard/getOrderHistoryList/export",
      { data: params }
    );
  },
  // 是否多级，false多级
  currentUid(params = {}) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/muti/currentUid", { params });
  },
  exportPartnerListData(params) {
    return ucHbg.post(
      "/hbg/uc/hbg/open/invite/v2/multi/data/exportPartnerListData",
      { data: params }
    );
  },
  getPartnerInfoStatistics(params) {
    return ucHbg.post(
      "/hbg/uc/hbg/open/invite/v2/multi/data/getPartnerInfoStatistics",
      { data: params }
    );
  },
  exportCommissionListData(params) {
    return ucHbg.post(
      "/hbg/uc/hbg/open/invite/v2/multi/data/exportCommissionListData",
      { data: params }
    );
  },
  isWhiteListUser(params = {}) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/dashboard/isWhiteListUser", {
      params,
    });
  },
  getBalanceInfoList(params = {}) {
    return ucHbg.get(
      "/hbg/uc/hbg/open/invite/v2/dashboard/getBalanceInfoList",
      { params }
    );
  },
  getSpotOpenOrderList(params = {}) {
    return ucHbg.get(
      "/hbg/uc/hbg/open/invite/v2/dashboard/getSpotOpenOrderList",
      { params }
    );
  },
  getSpotHistoryOrderList(params = {}) {
    return ucHbg.get(
      "/hbg/uc/hbg/open/invite/v2/dashboard/getSpotHistoryOrderList",
      { params }
    );
  },
  contractInfo(params = {}) {
    // let headers = {source:'web'};
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/dashboard/getPairs", {
      params,
    });
  },
  symbolsInfo(params = {}) {
    // let headers = {source:'web'};
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/dashboard/getSymbols", {
      params,
    });
  },
  updateUserRemark(params) {
    return ucHbg.post("/hbg/uc/hbg/open/invite/v2/dashboard/updateRemark", {
      data: params,
    });
  },
  getExportCenterList(params = {}) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/dashboard/exportCenter/list", {
      params,
    });
  },
  updateParterRemark(params) {
    return ucHbg.post("/hbg/uc/hbg/open/invite/v2/multi/data/remark", {
      data: params,
    });
  },
  getSpecialUid(params = {}) {
    return ucHbg.get("/hbg/open/invite/brokerage/income/crm", { params });
  },

  //https://yapi.huobiapps.com/project/2138/interface/api/87770
  //新获取资源位列表接口
  bannerList(params) {
    return pro.get(`/hbg/v1/config/push/banner/list`, {
      params,
    });
  },
  /**v
   *  KOL 2.0end--------------------------------------------
   * */

  // 合伙人下级确认页
  addPartnerGetInfo(params) {
    return ucHbg.get(`/hbg/uc/hbg/open/invite/v2/muti/add_partner_get_info`, {
      params,
    });
    // return Promise.resolve({code: 200, data: {uid: '2324234342', contractRate: '1%', rebateRate: '2%'}})
  },
  
  addPartner(params) {
    return ucHbg.get(`/hbg/uc/hbg/open/invite/v2/muti/add_partner`, { params });
    //  return Promise.resolve({code: 100620, data: {uid: '2324234342', contractRate: '1%', rebateRate: '2%'}})
  },

  report(params) {
    return ucHbg.post(`/hbg/uc/hbg/open/invite/v2/muti/report`, { data:params });
  },

  //邀请人返现比例修改
  inviteRateSettingGetInfo(params) {
    return ucHbg.get(`/hbg/uc/hbg/open/invite/v2/muti/invite_rate_setting_get_info`, { params });
  },

  // 邀请人返现比例修改
  setInviteRate(params) {
    return ucHbg.get(`/hbg/uc/hbg/open/invite/v2/muti/invite_rate_setting`, params);
  },
  // 多级返现比例修改
  setMutiRate(params) {
    return ucHbg.get(`/hbg/uc/hbg/open/invite/v2/muti/muti_rate_setting`, params);
  },
  
  // 多级返佣比例修改
  mutiRateSettingGetInfo(params) {
    return ucHbg.get(`/hbg/uc/hbg/open/invite/v2/muti/muti_rate_setting_get_info`, { params });
  },

  brokerageRank(params) {
    return pro.get(`/pro/v1/inviter/brokerage/rank`, { params });
    // return Promise.resolve<any>({
    //   "status": 'ok',
    //   code: 200,
    //   "data": {
    //     "rank-list": [
    //       {
    //         rank: 1,
    //         account: '202',
    //         'broker-id': 2,
    //         'invitee-total': 2,
    //         'brokerage-sum': 2,
    //         'head-icon': '',
    //         'broker-did': '2222',
    //         'broker-uid': '2222',
    //       },
    //       {
    //         rank: 2,
    //         account: '202',
    //         'broker-id': 2,
    //         'invitee-total': 2,
    //         'brokerage-sum': 2,
    //         'head-icon': '',
    //         'broker-did': '2222',
    //         'broker-uid': '2222',
    //       }, {
    //         rank: 3,
    //         account: '202',
    //         'broker-id': 2,
    //         'invitee-total': 2,
    //         'brokerage-sum': 2,
    //         'head-icon': '',
    //         'broker-did': '2222',
    //         'broker-uid': '2222',
    //       }, {
    //         rank: 4,
    //         account: '202',
    //         'broker-id': 2,
    //         'invitee-total': 2,
    //         'brokerage-sum': 2,
    //         'head-icon': '',
    //         'broker-did': '2222',
    //         'broker-uid': '2222',
    //       }, {
    //         rank: 5,
    //         account: '202',
    //         'broker-id': 2,
    //         'invitee-total': 2,
    //         'brokerage-sum': 2,
    //         'head-icon': '',
    //         'broker-did': '2222',
    //         'broker-uid': '2222',
    //       }, {
    //         rank: 6,
    //         account: '202',
    //         'broker-id': 2,
    //         'invitee-total': 2,
    //         'brokerage-sum': 2,
    //         'head-icon': '',
    //         'broker-did': '2222',
    //         'broker-uid': '2222',
    //       }, {
    //         rank: 7,
    //         account: '202',
    //         'broker-id': 2,
    //         'invitee-total': 2,
    //         'brokerage-sum': 2,
    //         'head-icon': '',
    //         'broker-did': '2222',
    //         'broker-uid': '2222',
    //       }, {
    //         rank: 8,
    //         account: '202',
    //         'broker-id': 2,
    //         'invitee-total': 2,
    //         'brokerage-sum': 2,
    //         'head-icon': '',
    //         'broker-did': '2222',
    //         'broker-uid': '2222',
    //       }, {
    //         rank: 9,
    //         account: '202',
    //         'broker-id': 2,
    //         'invitee-total': 2,
    //         'brokerage-sum': 2,
    //         'head-icon': '',
    //         'broker-did': '2222',
    //         'broker-uid': '2222',
    //       }, {
    //         rank: 10,
    //         account: '202',
    //         'broker-id': 2,
    //         'invitee-total': 2,
    //         'brokerage-sum': 2,
    //         'head-icon': '',
    //         'broker-did': '2222',
    //         'broker-uid': '2222',
    //       }
    //     ],
    //     "person-rank": {
    //       rank: 998,
    //       account: '202',
    //       'broker-id': 2,
    //       'invitee-total': 2,
    //       'brokerage-sum': 2,
    //       'head-icon': '',
    //       'broker-did': '2222',
    //       'broker-uid': '2222',
    //     }
    //   }
    // })
  },
  // 是否首次返佣
  getSasRebate(params) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/rebate/reward/hasRebate", { params });
  },
  // 待召回
  GetUserLostList(params) {
    return ucHbg.get(
      "/hbg/uc/hbg/open/invite/v2/dashboard/getUserLostList",
      { params }
    )
  },
  // 发送召回提醒
  sendRecall(params = {}) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/dashboard/sendRecall", { params });
  },
};
// 双向返佣相关接口
export const doubleInvite = {
  // 创建双向返佣邀请码
  createInviteCode(data) {
    return ucHbg.post("/hbg/uc/hbg/open/invite/v2/invite_code/create", data);
  },
  createInviteSave(data) {
    // 邀请码返佣比例修改
    return ucHbg.post("/hbg/uc/hbg/open/invite/v2/invite_code/rate/save", data);
  },
  modify(data) {
    // 修改邀请码，默认邀请码，备注
    return ucHbg.post(
      "/hbg/uc/hbg/open/invite/v2/invite_code/default/set",
      data
    );
  },
  getDefaultCode(params) {
    // 获取当前用户的默认邀请码（v1,v2的聚合）
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/invite_code/default/get", {
      params,
    });
  },
  getInviteCodeList(params) {
    // 获取当前用户下的邀请码列表-聚合v1与v2
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/invite_code/list", {
      params,
    });
  },

  //http://phabricator.huobidev.com/w/dawn/pro-api/v1/rake-back/#get-v1-inviter-brokerage-aggregation-day
  getCashbackAggregation(params) {
    return ucHbg.get("/pro/v1/inviter/brokerage/aggregation/day", {
      params,
    });
  },
  getFirendList(params) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/commission/invite/list", {
      params,
    });
  },
  getInvitedCount(params) {
    // 获取总邀请人数
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/inviter/get", {
      params,
    });
  },
  getInviteUserType(params) {
    // 查看当前用户是否为黑名单
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/inviter/kol", {
      params,
    });
  },
  checkKol(params) {
    // 查询当前登入用户是kol/散户 // 新的双反
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/inviter_award/checkKol", {
      params,
    });
  },
  getNewInviteListInfo(params) {
    // 邀请人列表
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/inviter_award/list", {
      params,
    });
  },
  getNewInviteListInfoDetail(params) {
    // 邀请人列表详情用
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/inviter_award/list_all", {
      params,
    });
  },
  getRedPocketNum(params = {}) {
    // 待领取红包数量
    return ucHbg.get(
      "/hbg/uc/hbg/open/invite/v2/inviter_award/red_pocket_num",
      {
        params,
      }
    );
  },
  getPackInfo(params) {
    // 背包明细
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/inviter_award/pack_info", {
      params,
    });
  },
  openRedPocket(data) {
    // 领取奖励,开启红包
    return ucHbg.post(
      "/hbg/uc/hbg/open/invite/v2/inviter_award/open_red_pocket",
      data
    );
  },
  openGift(data) {
    // 开启礼盒
    return ucHbg.post(
      "/hbg/uc/hbg/open/invite/v2/inviter_award/open_box",
      data
    );
  },
  getRedPocketList(params) {
    // 红包明细
    return ucHbg.get(
      "/hbg/uc/hbg/open/invite/v2/inviter_award/red_pocket_list",
      {
        params,
      }
    );
  },
  getNewInviteCode(params) {
    // 获取邀请码
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/inviter_award/invite_code", {
      params,
    });
  },
  openAward(data) {
    // 开启礼盒
    return ucHbg.get(
      "/hbg/uc/hbg/open/invite/v2/inviter_award/open_award",
      data
    );
  },
  getSpringState(params) {
    // 是否在主会场期间
    return ucHbg.get(`@hbg/v1/prime-box/period/get`, {
      params,
    });
  },
  show(params) {
    // 用户投票接口
    return ucHbg.get(`@hbg/v1/prime-box/user/elfin/show`, {
      params,
    });
  },
  pushMsg(params) {
    return ucHbg.get(`/hbg/uc/hbg/open/invite/v2/inviter_award/push_msg`, {
      params,
    });
  },
  shareDraw(params = {}) {
    return ucHbg.get(`/hbg/uc/hbg/open/invite/v2/inviter_award/share_draw`, {
      params,
    });
  },
  boxNum(params) {
    return ucHbg.get(`/hbg/uc/hbg/open/invite/v2/inviter_award/box_num`, {
      params,
    });
  }, //http://phabricator.huobidev.com/T346036
  activitiesPrize(params) {
    return ucHbg.get(
      `@pro/v1/inviter/brokerage/spanish/team/activities/prize`,
      {
        params,
      }
    );
  }, //https://yapi.huobiapps.com/project/1820/interface/api/65754
  myTotalPrize(params) {
    return ucHbg.get(`@hbg-newlisting/newlisting/es/mytotalprize`, {
      params,
    });
  },
  updateOverturnStatus(params) {
    return ucHbg.post(`@hbg/v1/prime-box/user/update-overturn-status`, {
      params,
    });
  },
};

export const getspecialDomain = () => {
  return hbg.get(`/hbg/uc/hbg/open/invite/v2/kol/specialNameUrl`, {});
};

export const miningApi = {
  
  miningActivityPrimeCheck(params) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/mining/activity/primeCheck", {
      params,
    })},

  inviteAlert(params) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/common/alert", {params});
  },
  kolExamineAlter() {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/kol/kolExamineAlter", {});
  },
}
